import React, { Component } from 'react';
import { Hyperlink } from './Hyperlink';
import { withUser } from '../user/UserContext';
import { isUrlInternal } from '../utils/url-utils/urlUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from './modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../user/user.types';

type Props = {
  className: string;
  url: string;
  source: string;
  children: React.ReactNode;
  /**
   * For some links, we want to show the href even if the user is not premium
   */
  enableHrefForSnapshots?: boolean;
} & WithRestrictedModalProps &
  UserContextType;

export class RawHyperlinkRestrictedBaseModal extends Component<Props> {
  static defaultProps = {
    className: '',
  };

  render() {
    const {
      className,
      url,
      source,
      children,
      accessPremium,
      openRestrictedModal,
      enableHrefForSnapshots,
    } = this.props;
    return (
      <Hyperlink
        className={className}
        {...(accessPremium
          ? {
              href: url,
              source: isUrlInternal(url) ? source : '',
            }
          : {
              ...(enableHrefForSnapshots && url ? { href: url } : {}),
              onClick: () => openRestrictedModal(source),
            })}
      >
        {children}
      </Hyperlink>
    );
  }
}

export const HyperlinkRestrictedBaseModal = withRestrictedModal(
  withUser(RawHyperlinkRestrictedBaseModal),
);
